import { useMutation, useQuery } from 'react-query';
import userTasksApi from '../apis/userTaskStats';

const { fetchUserTasksList } = userTasksApi;

export const useGetUserTasksStats = (
  remark,
  onSuccess,
  onError
) =>
  useQuery(
    [
      '' + remark,
    ],
    () =>
      fetchUserTasksList(),
    {
      onSuccess,
      onError,
    }
  );
